import { Select, Option } from "@tokenterminal/ui/Input/Select"
import { Dropdown, type DropdownOption } from "components/Dropdown"
import { useDatasetsList } from "modules/v3/DatasetsAside/useDatasetsList"
import Router from "next/router"
import { useCallback, useMemo } from "react"
import type { Mart } from "types/ApiTypes"

type PartialMart = Pick<Mart, "name" | "slug">

export const DatasetSelector = ({ mart }: { mart: PartialMart }) => {
  const marts = useDatasetsList()
  const options: Array<DropdownOption<string>> = useMemo(
    () =>
      marts.map(({ name, slug }) => ({
        label: name,
        value: slug,
      })),
    [marts]
  )

  const onSelect = useCallback((slug: string) => {
    if (slug) {
      Router.push(`/datasets/${slug}`, undefined, {
        shallow: false,
      })
    }
  }, [])

  return (
    <Select
      id="source-type"
      name="source-type"
      onChange={onSelect}
      defaultSelected={mart.slug}
    >
      {options.map(({ label, value }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  )
}

export const DatasetSelectorSkeleton = ({ mart }: { mart: PartialMart }) => {
  return (
    <Dropdown
      onChange={() => {}}
      items={[
        {
          label: mart.name,
          value: mart.slug,
        },
      ]}
    />
  )
}
